import { render, staticRenderFns } from "./ChildrenShort.vue?vue&type=template&id=126461aa"
import script from "./ChildrenShort.vue?vue&type=script&lang=js"
export * from "./ChildrenShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports